import React from "react";
import { Button, Div } from "@vkontakte/vkui";
import styles from "./TimeTable.style";
import { mapHoursMinutesToCorrectLength } from "../../../utils";
import { connect } from "react-redux";
import { selectSlot } from "../../../redux/actions/datesActions";
import { setActivePanel } from "../../../redux/actions/panelsActions";
import { panels } from "../../../variables";

const TimeTable = ({ slots, selectSlot, goToConfirmPanel }) => {
  const splitSlotsForFiveGroups = (slots) => {
    const splitedSlots = [];
    for (let i = 0; i < slots.length; i += 4) {
      splitedSlots.push({
        first: slots[i],
        second: slots[i + 1],
        third: slots[i + 2],
        fourth: slots[i + 3],
      });
    }
    return splitedSlots;
  };

  const getReadableTimeFromSlot = (slot) => {
    const newDate = new Date(slot.visitTime);
    return (
      newDate.getHours() +
      ":" +
      mapHoursMinutesToCorrectLength(newDate.getMinutes())
    );
  };

  return (
    <>
      {splitSlotsForFiveGroups(slots).map((slot) => {
        return (
          <Div style={{ display: "flex", justifyContent: "left" }}>
            {slot.first ? (
              <Button
                onClick={() => {
                  selectSlot(slot.first);
                  goToConfirmPanel();
                }}
                style={styles.button}
              >
                {getReadableTimeFromSlot(slot.first)}
              </Button>
            ) : (
              <Div style={styles.button} />
            )}
            {slot.second ? (
              <Button
                onClick={() => {
                  selectSlot(slot.second);
                  goToConfirmPanel();
                }}
                style={styles.button}
              >
                {getReadableTimeFromSlot(slot.second)}
              </Button>
            ) : (
              <Div style={styles.button} />
            )}
            {slot.third ? (
              <Button
                onClick={() => {
                  selectSlot(slot.third);
                  goToConfirmPanel();
                }}
                style={styles.button}
              >
                {getReadableTimeFromSlot(slot.third)}
              </Button>
            ) : (
              <Div style={styles.button} />
            )}
            {slot.fourth ? (
              <Button
                onClick={() => {
                  selectSlot(slot.fourth);
                  goToConfirmPanel();
                }}
                style={styles.button}
              >
                {getReadableTimeFromSlot(slot.fourth)}
              </Button>
            ) : (
              <Div style={styles.button} />
            )}
          </Div>
        );
      })}
    </>
  );
};

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    selectSlot: (slot) => dispatch(selectSlot(slot)),
    goToConfirmPanel: () => dispatch(setActivePanel(panels.confirmPanel)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TimeTable);
